export const formatMoney = (value, currency) => {
    if (!value || !value.toFixed) {
        value = 0
    }
    value /= 100

    return value.toFixed(2) + ' ' + getCurrencySymbol(currency)
}


export const getCurrencySymbol = (currency) => {
    switch (currency) {
    case 'EUR':
        return '€';
    case 'GBP':
        return '£';
    case 'CHF':
        return 'CHF';
    case 'SEK':
        return 'SEK';
    default:
        return '*';
    }
}

export const convertToCents = (num) => {
    return Math.round(num * 100);
}



// WEBPACK FOOTER //
// ./src/util/money.js